import { ParseCapsuleProjectResponse } from "@app/api/BaseAPI";
import {
	GetCapsuleProjectByID,
	GetCapsuleProjects,
} from "@app/api/CapsuleProjects";
import { cacheTime } from "@app/app";
import {
	emptyProject,
	type ProjectSummary,
} from "@app/interfaces/ProjectSummary";
import { useQuery } from "@tanstack/react-query";

export const useProject = (projectID?: string | null) => {
	return useQuery({
		queryKey: ["project", projectID],
		queryFn: () =>
			GetCapsuleProjectByID(Number(projectID)).then((resp) => {
				if (resp == null) {
					return null;
				}
				const res = ParseCapsuleProjectResponse(resp.kase);
				if (res == null) {
					return emptyProject;
				}
				return res;
			}),
		enabled: projectID != null && projectID !== "",
	});
};

export const useProjects = () => {
	return useQuery({
		queryKey: ["projects"],
		queryFn: async () => {
			const batchSize = 5;
			let firstPage = 1;
			const allProjects: ProjectSummary[] = [];

			while (true) {
				const pages = await Promise.all(
					Array.from({ length: batchSize }, (_, index) =>
						GetCapsuleProjects(firstPage + index),
					),
				);
				const hasEmptyPage = pages.some(
					({ projects }) => projects.length === 0,
				);

				allProjects.push(...pages.flatMap(({ projects }) => projects));

				if (hasEmptyPage) {
					break;
				}

				firstPage += batchSize;
			}

			return allProjects;
		},
		staleTime: cacheTime,
	});
};
